module.exports = __webpack_public_path__ + "img/siren.392b9031.png";